import { Editor, EditorModule } from 'primeng/editor';
import { ViewHtmlButtonDirective } from '../../../directives/view-html-button.directive';
import { EmojiPickerButtonComponent } from '../../../components/emoji-picker-button/emoji-picker-button.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ProductCategoryService } from '../../../api/product-category.service';
import { ProductionZonesService } from '../../../api/production-zones.service';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { EditProductPanelService } from '../../../services/edit-product-panel.service';
import { FuseTranslationLoaderService } from '../../../../../@fuse/services/translation-loader.service';
import { OrdersService } from '../../../api/orders.service';
import { GT2PageAbstract } from '../../abstract/GT2PageAbstract';
import { Settings } from '../../../settings/settings';
import { ValidatorHelper } from '../../../validators/ValidatorHelper';
import { locale as english } from '../i18n/en-CA';
import { locale as french } from '../i18n/fr-CA';
import { FormControl } from '@angular/forms';
import { ModulesService } from '../../../services/modules.service';
import { CountryContextService } from '../../../services/country-context.service';
import { MatButtonModule } from '@angular/material/button';
import { FuseDirectivesModule } from '../../../../../@fuse/directives/directives';
import { FusePipesModule } from '../../../../../@fuse/pipes/pipes.module';
import { MatInputModule } from '@angular/material/input';
import { FuseSidebarModule } from '../../../../../@fuse/components';
import { CommonModule } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { Select2Module } from 'ng-select2-component';
import { MatIconModule } from '@angular/material/icon';
import { WrappingService } from '../../../api/wrapping.service';
import { SpecificConditionService } from '../../../api/specific-condision.service';
import { ProposalComposeService } from '../../../api/proposal-compose.service';
import { ProposalComposeCTService } from '../../../api/proposal-compose-ct.service';
import { OrderComposeService } from '../../../api/order-compose.service';
import { InvoiceComposeService } from '../../../api/invoice-compose.service';
import { InvoiceComposeCTService } from '../../../api/invoice-compose-ct.service';
import { InvoiceComposeGlobalPaymentsService } from '../../../api/invoice-compose-global-payments.service';
import { CatererService } from '../../caterer/caterer.service';
import { ConseillersService } from '../../../api/conseillers.service';
import { ReportsService } from '../../../reports/reports.service';
import { ReportFactoryService } from '../../../reports/report-factory.service';
import { MenuReportsService } from '../../../reports/menu-reports.service';
import { ReceiptNoticeComposeService } from '../../../api/receipt-notice-compose.service';
import { ReceiptNoticeSellOnlyComposeService } from '../../../api/receipt-notice-sell-only-compose.service';
import { StorageNoticeComposeService } from '../../../api/storage-notice-compose.service';
import { Gt2SelectComponent } from '../../../components/gt2-select/gt2-select.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatOptionModule } from '@angular/material/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTabsModule } from '@angular/material/tabs';

@Component({
  selector: 'app-edit-product',
  templateUrl: './edit-product.component.html',
  styleUrls: ['./edit-product.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    MatFormFieldModule,
    MatButtonModule,
    ReactiveFormsModule,
    FuseDirectivesModule,
    FusePipesModule,
    MatSelectModule,
    MatCheckboxModule,
    MatTabsModule,
    MatInputModule,
    TranslateModule,
    FuseSidebarModule,
    EditorModule,
    ViewHtmlButtonDirective,
    EmojiPickerButtonComponent,
    Gt2SelectComponent,
    MatProgressSpinnerModule,
    MatTooltipModule,
    MatOptionModule,
    CommonModule,
    MatMenuModule,
    NgxMaterialTimepickerModule,
    Select2Module,
    MatIconModule,
  ],
  providers: [
    WrappingService,
    SpecificConditionService,
    ProposalComposeService,
    ProposalComposeCTService,
    OrderComposeService,
    InvoiceComposeService,
    InvoiceComposeCTService,
    InvoiceComposeGlobalPaymentsService,
    CatererService,
    ConseillersService,
    ReportsService,
    ReportFactoryService,
    MenuReportsService,
    ReceiptNoticeComposeService,
    ReceiptNoticeSellOnlyComposeService,
    StorageNoticeComposeService,
  ],
})
export class EditProductComponent
  extends GT2PageAbstract
  implements OnInit, AfterViewInit, OnDestroy
{
  @ViewChild('txtEditor', { static: false }) txtEditor!: Editor;
  product: any;
  productCategory: any;
  productCategoryIsDeleted: boolean = false;
  orderUUID!: string;
  parentUUID!: string;
  override loading: boolean = false;
  form!: FormGroup | any;
  priceForm!: FormGroup | any;
  chargedPriceForm!: FormGroup | any;

  noteInvalid: boolean = false;
  noteSubscription: any;
  editable: boolean = false;
  zones = new FormControl('');
  zonesList: any[] = [];
  productionZones: string[] = [];
  isComboChild: boolean = false;

  constructor(
    private panelService: EditProductPanelService,
    private translationLoader: FuseTranslationLoaderService,
    private formBuilder: FormBuilder,
    public translate: TranslateService,
    public dialog: MatDialog,
    public router: Router,
    public productCategoryService: ProductCategoryService,
    public productionZonesService: ProductionZonesService,
    public ordersService: OrdersService,
    public modulesService: ModulesService,
    private cdr: ChangeDetectorRef,
    public countryContext: CountryContextService,
  ) {
    super();
    this.translationLoader.loadTranslations(english, french);

    const data = this.panelService.getData();
    if (data) {
      this.product = data.product;
      this.isComboChild = data.isComboChild ?? false;
      this.productCategory = data.productCategory;
      this.orderUUID = data.orderUUID;
      this.parentUUID = data.parentUUID ?? '';
      this.editable = data.editable ?? false;
      if (Array.isArray(this.product.production_zones)) {
        // Zones may arrive as API objects ({uuid, name}) or as bare uuid
        // strings; anything without a uuid is dropped so the API never
        // receives a null entry.
        this.productionZones = this.product.production_zones
          .map((zone: any) => (typeof zone === 'string' ? zone : zone?.uuid))
          .filter((uuid: any) => typeof uuid === 'string' && uuid !== '');
      }
    }

    this.form = this.formBuilder.group({
      name: [
        { value: '', disabled: !this.editable },
        [
          Validators.minLength(Settings.inputMinChar),
          Validators.maxLength(Settings.inputMaxCharMid),
          Validators.required,
        ],
      ],
      name_fr_CA: [
        { value: '', disabled: !this.editable },
        [
          Validators.minLength(Settings.inputMinChar),
          Validators.maxLength(Settings.inputMaxCharMid),
          Validators.required,
        ],
      ],
      name_internal_fr_CA: [
        { value: '', disabled: !this.editable },
        [
          Validators.minLength(Settings.inputMinChar),
          Validators.maxLength(Settings.inputMaxCharMid),
          Validators.required,
        ],
      ],
      name_internal_en_CA: [
        { value: '', disabled: !this.editable },
        [
          Validators.minLength(Settings.inputMinChar),
          Validators.maxLength(Settings.inputMaxCharMid),
          Validators.required,
        ],
      ],
      description_fr_CA: [
        '',
        [Validators.maxLength(Settings.inputMaxCharLong)],
      ],
      description_en_CA: [
        '',
        [Validators.maxLength(Settings.inputMaxCharLong)],
      ],
      prod_note: ['', [Validators.maxLength(Settings.inputMaxCharLong)]],
      sale_note: ['', [Validators.maxLength(Settings.inputMaxCharLong)]],
      quantity: [
        { value: '', disabled: !this.editable },
        [Validators.required],
      ],
    });

    this.priceForm = this.formBuilder.group({
      unit_price: [
        { value: '', disabled: !this.editable },
        [ValidatorHelper.isValidPriceNumber],
      ],
    });
    this.chargedPriceForm = this.formBuilder.group({
      unit_price: [
        { value: '', disabled: !this.editable },
        [ValidatorHelper.isValidPriceNumber],
      ],
    });

    this.productionZonesService.getDataList().subscribe(
      (response) => {
        this.zonesList = response.data;
      },
      (error) => {},
    );
  }

  ngOnInit() {}

  ngAfterViewInit() {
    if (this.txtEditor) {
      this.noteSubscription = this.txtEditor.onTextChange.subscribe((data) => {
        this.noteInvalid = data.htmlValue.length > Settings.editorMaxCharLong;
      });
    }
  }

  ngOnDestroy() {
    if (this.noteSubscription) {
      this.noteSubscription.unsubscribe();
    }
  }

  public onSaveProduct(closeDialog: boolean = true) {
    this.product.product_category = this.productCategory;
    this.product.parent_uuid = this.parentUUID;
    this.loading = true;

    if (this.product.show_charged_price && this.modulesService.hasJLReport()) {
      this.product.unit_price = this.product.charged_price;
    }
    // Send the selected zone uuids on a copy: `this.product` is shared by
    // reference with the order page, and overwriting its production_zones
    // (objects) with uuid strings breaks the next opening of this panel.
    const payload = { ...this.product, production_zones: this.productionZones };
    this.loading = true;
    this.ordersService.updateProducts(this.orderUUID, [payload]).subscribe(
      (response: any) => {
        this.loading = false;
        if (closeDialog) {
          this.panelService.emitResult(response.data);
        } else {
          for (const prodCol of response.data.product_category_collection) {
            for (const product of prodCol.product_collection) {
              if (product.uuid == this.product.uuid) {
                this.product = product;
                break;
              }
            }
          }
        }
        this.cdr.detectChanges();
      },
      (error: any) => {
        this.loading = false;
        this.handleAPIError(error, this.dialog, null, null, this.router);
      },
    );
  }

  public onProductCategoryChange(event: any) {
    this.productCategory = event;
    this.productCategoryIsDeleted = event?.is_deleted === true;
  }

  public onProductShowPrice(checked: boolean) {
    this.product.show_charged_price = checked;
    this.evaluateShowPrice();
    if (!checked) {
      this.onSaveProduct(false);
    }
  }

  public evaluateShowPrice() {
    if (this.product.show_charged_price) {
      this.product.unit_price = parseFloat(this.product.charged_price);
    } else {
      this.product.unit_price = 0;
    }
  }

  public productZonesChange(event: any) {
    this.productionZones = event.value;
  }

  public close(): void {
    this.panelService.emitResult(false);
  }
}
